/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitFormRequest} from '@cash-web/protos/squareup/franklin/app/submit_form.pb'
import {SubmitFormResponse} from '@cash-web/protos/squareup/franklin/app/submit_form.pb'


export const submitForm = (request: SubmitFormRequest, options?: CashRequestOptions) => post<SubmitFormRequest, SubmitFormResponse>("/2.0/cash/submit-form", request, {...options, rejectOnError: true })